import React, { useEffect, useState } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';

ChartJS.register(
    ArcElement,
    Tooltip,
)




const TodoChart = ({task}) => {
    const [taskChart, setTaskChart] = useState([])

    const data = {
        labels: [
            'Total',
            'Completed',
            'Waiting',
            'InProgress'
        ],
        datasets: [{
            label: 'Todo List',
            data: taskChart,
            backgroundColor: [
                'rgb(2,49,157)',
                'rgb(88, 255, 105)',
                'rgb(62, 197, 255)',
                'rgb(255, 75, 4)',
            ],
            hoverOffset: 4
        }]
    };
    
    const options = {
        responsive: true,
        maintainAspectRatio: false,
    };

    useEffect(()=>{
        if (!task) return; // Return early if task is falsy

        const { total, completed, waiting, inprogress } = task.reduce((acc, item) => {
            // Increment the corresponding status count based on the item's status
            switch (item.status) {
                case 'Completed':
                    acc.completed++;
                    break;
                case 'Waiting':
                    acc.waiting++;
                    break;
                case 'InProgress':
                    acc.inprogress++;
                    break;
            }
            acc.total++; // Increment total count for each item
            return acc;
        }, { total: 0, completed: 0, waiting: 0, inprogress: 0 }); // Initialize accumulator object

        // Update the state with the counts
        setTaskChart([total, completed, waiting, inprogress])
    },[task])

  return (
    <div className="todo__chart-container">

        <h4 className="todo__chart-title">
            Stats for {moment().format('MMMM YYYY')}
        </h4>
        
        <div className="todo__chart">
            <Doughnut data={data} options={options} />
        </div>
        
        <div className="todo__chart-content">
            <h4 className="todo__chart-content_title">Todo List</h4>
            <div className="todo__chart-items">
                <div className="todo__chart-box all">
                    <h4 className="todo__chart-box_title">Total</h4>
                    <p className="todo__chart-box_count">
                        <span></span>
                        {task?.length}
                    </p>
                </div>
                <div className="todo__chart-box completed">
                    <h4 className="todo__chart-box_title">Completed</h4>
                    <p className="todo__chart-box_count">
                        <span></span>
                        {task?.filter((item)=>item?.status === 'Completed')?.length}
                    </p>
                </div>
                <div className="todo__chart-box waiting">
                    <h4 className="todo__chart-box_title">Waiting</h4>
                    <p className="todo__chart-box_count">
                        <span></span>
                        {task?.filter((item)=>item?.status === 'Waiting')?.length}
                    </p>
                </div>
                <div className="todo__chart-box inprogress">
                    <h4 className="todo__chart-box_title">InProgress</h4>
                    <p className="todo__chart-box_count">
                        <span></span>
                        {task?.filter((item)=>item?.status === 'InProgress')?.length}
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default TodoChart